import React from 'react';

export default function EmptyState({ icon: Icon, title, description, action, onAction }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 text-center px-6">
      <div
        className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4"
        style={{ background: 'rgba(255,255,255,0.05)' }}
      >
        <Icon className="w-8 h-8" style={{ color: '#475569' }} />
      </div>
      <h3 className="text-base font-semibold text-white mb-2">{title}</h3>
      <p className="text-sm leading-relaxed max-w-xs" style={{ color: '#64748B' }}>
        {description}
      </p>
      {action && onAction && (
        <button
          onClick={onAction}
          className="mt-5 px-4 py-2 rounded-xl text-sm font-medium transition-all active:scale-95 border"
          style={{ color: '#94A3B8', borderColor: '#2D3748', background: '#1A2433' }}
          data-testid="empty-state-action-btn"
        >
          {action}
        </button>
      )}
    </div>
  );
}
